import { IEnumOption } from 'modules/shared/interfaces/enumOptions';

export enum EndUsersCountChartType {
	NEW,
	ACTIVE,
}

export const endUsersCountChartTypeEnumOptions: IEnumOption[] = [
	{
		label: 'New users',
		value: EndUsersCountChartType.NEW,
	},
	{
		label: 'Active users',
		value: EndUsersCountChartType.ACTIVE,
	},
];
